import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { error } from 'console';
import { forkJoin } from 'rxjs';
import { ASCFacilities } from 'src/app/models/ASCFacilities';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IReferralDetails } from 'src/app/models/IReferralDetails';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Defaults } from 'src/app/Utilities/defaults';

export class ConfirmDialogModel {
  constructor(public title: string, public message: string, public patientId: number = 0) {
  }
}

@Component({
  selector: 'app-followup-surgery-referral',
  templateUrl: './followup-surgery-referral.component.html',
  styleUrls: ['./followup-surgery-referral.component.css']
})
export class FollowupSurgeryReferralComponent implements OnInit {
  ASCReferralForm: FormGroup;
  title: string;
  patientName: string = '';
  patientId: number = 0;
  dpatId: number = 0;
  patientDOB: string = '';
  constructor(public dialogRef: MatDialogRef<FollowupSurgeryReferralComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel, private sharedService: SharedService,
    private personalService: PersonalInfoService,
    private schedulerservice: SchedularServiceService, private fb: FormBuilder) {
    // Update view with given values
    this.title = data.title;
  }

  ngOnInit() {
    this.ASCReferralForm = this.fb.group({
      ascFacility: ['', [Validators.required, this.selectionRequiredValidator]],
      ascLocation: ['', [Validators.required, this.selectionRequiredValidator]],
      ascProvider: [''],
      ascReason: ['']
    });

    this.patientName = sessionStorage.getItem('patientName') || '';
    this.dpatId = Number(sessionStorage.getItem('DPatId')) || 0;
    this.patientId = Number(sessionStorage.getItem("patientId")) || 0;
    this.patientDOB = sessionStorage.getItem('patientDob') || '';
    this.getChildFacilityInfo();
  }

  ASCFacilities: ASCFacilities[] = [];
  getChildFacilityInfo() {
    this.sharedService.getASCFacilityInfo().subscribe((result: any) => {
      if (result != null && result.length > 0) {
        this.ASCFacilities = []
        this.ASCFacilities = result;
        if (this.ASCFacilities.length > 0) {
          this.ASCReferralForm.patchValue({
            ascFacility: this.ASCFacilities[0].ASCFaciltyId
          });
          this.ONFacilityChange(this.ASCFacilities[0].ASCFaciltyId);
        }
      }
    }, (error) => {
      console.error('Error fetching ASC facility info:', error);
    });
  }
  ASCFacilityId: number = 0;
  async ONFacilityChange(val: any) {
    this.ASCFacilityId = val;
    if (this.ASCFacilityId > 0) {      
      await this.GetASCLocationList(this.ASCFacilityId);
    }
  }

  lstProviders: IUserDetails[] = []
  lstLocations: ILocationDetails[] = [];

  async GetASCLocationList(ascFacilityId: number) {
    this.schedulerservice.getLocations(ascFacilityId).subscribe((ascLocations) => {
      this.lstLocations = [];
      this.lstLocations = ascLocations;
      this.lstLocations = this.lstLocations.filter(a => a.active == true);
      if(this.lstLocations.length > 0){
        this.ASCReferralForm.patchValue({
            ascLocation: this.lstLocations[0].locationId
          });
        this.ONLocationChange(this.lstLocations[0].locationId);
      }
    }, (error) => {
      console.error('Error fetching ASC location info:', error);
    });
  }

  async ONLocationChange(locVal: any) {
    let ASCLocationId = locVal;
    if (ASCLocationId > 0) {
      await this.GetASCProviderList(ASCLocationId);
    }
  }

  async GetASCProviderList(ascLocationId: number) {
    this.sharedService.getselectedlocidByrole(Defaults.doctorType, ascLocationId, this.ASCFacilityId).subscribe(data => {
      this.lstProviders = [];
      this.lstProviders = data;
    })
  }

  selectionRequiredValidator(control: AbstractControl): ValidationErrors | null {
    return control.value && Number(control.value) !== 0 ? null : { selectionRequired: true };
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(null);
  }

  onSurgerySave() {
    if (!this.ASCReferralForm.valid) {
      return;
    }
    const saveParam = {
      ClinicPatinetId: this.patientId,
      ClinicFacilityId: Number(sessionStorage.getItem('FacilityId')) || 0,
      ASCFacilityId: this.ASCReferralForm.value.ascFacility || 0,
      ASCLocationId: this.ASCReferralForm.value.ascLocation || 0,
      ASCUserId: this.ASCReferralForm.value.ascProvider || '',
      Comments: this.ASCReferralForm.value.ascReason || '',
      CreatedUserId: sessionStorage.getItem('userId') || '',
      CurrentAppointmentId: sessionStorage.getItem('appId') || ''
    }
    this.dialogRef.close(saveParam);
  }
}
